window.addEventListener('DOMContentLoaded', () => {
    const progressBar = document.getElementById("progress-bar");
    const progressWrapper = document.querySelector('.article-progress-bar-wrapper');

    if (!progressBar || !progressWrapper) return;

    let isVisible = false;
    let revealTimeout = null;



    window.addEventListener("scroll", () => {
        const scrollTop = window.scrollY;
        const docHeight = document.documentElement.scrollHeight - window.innerHeight;

        // Reveal on first scroll (with slight delay)
        if (scrollTop > 0 && !isVisible) {
            revealTimeout = setTimeout(() => {
                progressWrapper.classList.add('is-visible');
                isVisible = true;
            }, 100);
        }

        // Hide again if user scrolls back to top
        if (scrollTop === 0 && isVisible) {
            clearTimeout(revealTimeout);
            progressWrapper.classList.remove('is-visible');
            isVisible = false;
        }

        // Update progress width
        const scrollPercent = docHeight > 0
            ? (scrollTop / docHeight) * 100
            : 0;

        progressBar.style.width = `${scrollPercent}%`;
    });
})